const PUSHER_KEY = import.meta.env.VITE_APP_PUSHER_API_KEY as string;
const PUSHER_CLUSTER = import.meta.env.VITE_APP_PUSHER_CLUSTER as string;

const pusherConfig = {
  key: PUSHER_KEY,
  cluster: PUSHER_CLUSTER,
};

export default pusherConfig;
